export default "__VITE_ASSET__7SRKTY1J__"